import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { GESTIONES_COMERCIALES } from "../constants/routes";
import { isPortalTermsRouteAllowed } from "../constants/portalTerms";
import { RootState } from "../store/combineReducer";

import { isPortalAccessBlocked } from "../hooks/useSyncMockBillingPolicy";

export default function PortalTermsGuard({ children }: { children: React.ReactNode }) {
  const { currentRole, portalTermsAccepted } = useSelector(
    (state: RootState) => state.user,
  );
  const location = useLocation();

  const mustAcceptTerms =
    currentRole === "COMPANY_ADMIN" && isPortalAccessBlocked(portalTermsAccepted);

  if (mustAcceptTerms && !isPortalTermsRouteAllowed(location.pathname)) {
    return (
      <Navigate
        to={`${GESTIONES_COMERCIALES}?currentTab=condiciones`}
        replace
        state={{ from: location }}
      />
    );
  }

  return <>{children}</>;
}
